import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { LoyaltyProgram } from '@rd/types';
import { RedeemCashV2WrapperComponentDirective } from '../../redeem-cash-v2-wrapper.component';

@Component({
  selector: 'rd-rcv2-checkout-banner-wrapper',
  template: '<ng-container #viewChild></ng-container>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RcV2CheckoutBannerWrapperComponent extends RedeemCashV2WrapperComponentDirective {
  @HostBinding('class.rd-rcv2-checkout-banner-wrapper') componentClass = true;
  @Input() redeemCashLoyaltyProgram: LoyaltyProgram;

  componentName = 'rcv2-checkout-banner';
}
